import React from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import { useGlobalLoader } from '../hooks/useGlobalLoader'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'

export const GlobalLoader = () => {
    const { isLoading } = useGlobalLoader()

    return (
        <Box sx={{ backgroundColor: (theme) => theme.header.background }}>
            <Fade in={isLoading} timeout={1000} easing={'ease-in-out'}>
                <LinearProgress aria-label='Loading...' sx={{ visibility: isLoading ? 'visible' : 'hidden' }} />
            </Fade>
        </Box>
    )
}
